/* ditto */
/**
 * scroll
 */
if (!customElements.get('before-after')) {
  class BeforeAfter extends HTMLElement {
    constructor() {
      super();
      this.parent   = this.closest('.before-after-image');
      this.slider   = this.querySelector('.before-after-image--slider');

      // adjustable
      this.SPEED_MULTIPLIER = 1.5;   // >1 = completes faster (2 for very fast)
      this.SMOOTHING        = 0.22;  // 0.1 = floaty, 0.3 = snappy
      this.START_THRESHOLD  = 0.3;   // 0 = start immediately, 0.3 = start when 30% of section is in viewport

      // internal-state
      this.targetPercent = 0;
      const initial = parseFloat(getComputedStyle(this.parent).getPropertyValue('--percent')) || 0;
      this.currentPercent = initial;
      this.rafId = null;
    }

    connectedCallback() {
      // scroll-animation
      window.addEventListener('scroll', this.updateOnScroll, { passive: true });
      window.addEventListener('resize', this.updateOnScroll, { passive: true });
      this.updateOnScroll();

      // drag-driven
      if (this.slider) {
        this.slider.addEventListener('input', (e) => {
          const percent = (e.target.value / 10); // slider 0–1000 → 0–100
          this.setTarget(percent);
        });
      }
    }

    // helpers
    clamp01(v) { return Math.min(Math.max(v, 0), 1); }

    setTarget(val) {
      this.targetPercent = Math.min(Math.max(val, 0), 100);
      this.kickRAF();
      if (this.slider) this.slider.value = this.targetPercent * 10; // sync slider
    }

    applyPercent(val) {
      this.parent.style.setProperty('--percent', String(val));
    }

    tick = () => {
      const diff = this.targetPercent - this.currentPercent;
      if (Math.abs(diff) < 0.05) {
        this.currentPercent = this.targetPercent;
        this.applyPercent(this.currentPercent);
        this.rafId = null;
        return;
      }
      this.currentPercent += diff * this.SMOOTHING;
      this.applyPercent(this.currentPercent);
      this.rafId = requestAnimationFrame(this.tick);
    };

    kickRAF() {
      if (this.rafId == null) this.rafId = requestAnimationFrame(this.tick);
    }

    // scroll-handler
    updateOnScroll = () => {
      const rect = this.getBoundingClientRect();
      const h = window.innerHeight;

      // delay-start
      let progress = ((h * (1 - this.START_THRESHOLD)) - rect.top) / h;

      // speed-multiplier
      progress = this.clamp01(progress * this.SPEED_MULTIPLIER);

      this.setTarget(progress * 100);
    };
  }

  customElements.define('before-after', BeforeAfter);
}
/* ditto */